<template>
  <div class="message-image">
    <el-image
      fit="cover"
      :initial-index="0"
      :preview-src-list="imageUrlList"
      preview-teleported
      :src="imageUrl"
      style="min-width: 180px; max-width: 320px; height: 100%"
    />
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  message: {
    type: Object,
    default: () => ({
      url: ''
    })
  }
})

const imageUrl = computed(() => props.message.url || '')
const imageUrlList = computed(() => (imageUrl.value ? [imageUrl.value] : []))
</script>

<style lang="scss" scoped>
.message-image {
  position: relative;
  box-sizing: border-box;
  width: 180px;
  height: 180px;
  overflow: hidden;
  cursor: pointer;
  border-radius: 8px;
}
</style>
